import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import { FiChevronDown } from 'react-icons/fi';
import { SectionHeading } from '../ui/SectionHeading';

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-white/10 bg-navy-800/50 rounded-2xl overflow-hidden mb-4 transition-colors hover:border-white/20">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none"
      >
        <span className="text-lg font-semibold text-white">{question}</span>
        <motion.div animate={{ rotate: isOpen ? 180 : 0 }} className="text-gray-400 shrink-0">
          <SafeIcon icon={FiChevronDown} className="text-xl" />
        </motion.div>
      </button>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="px-6 pb-5 text-gray-300"
          >
            {answer}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const FAQ = () => {
  const faqs = [
    {
      q: "I can’t afford it right now.",
      a: "You’re losing ₹50K–₹1L/month by not acting. This is an investment in a proven system that can pay for itself multipy times over if you implement it."
    },
    {
      q: "I don’t have enough time.",
      a: "Our simple step-by-step system is designed for busy people. You can go at your own pace and implement with just 1-2 hours a day."
    },
    {
      q: "I’m a complete beginner.",
      a: "Perfect! Silver 2.0 is designed for beginners. We take you from absolute zero to building a complete online income system with no prior tech skills required."
    }
  ];

  return (
    <section className="py-24 px-4 bg-navy-900 border-t border-white/5">
      <div className="max-w-3xl mx-auto">
        <SectionHeading subtitle="Common questions answered.">Still Thinking?</SectionHeading>
        <div className="mt-12">
          {faqs.map((faq, idx) => (
            <FAQItem key={idx} question={faq.q} answer={faq.a} />
          ))}
        </div>
      </div>
    </section>
  );
};